import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "store";
import { openModal } from "store/modals/slice";
import { ModalTypes } from "configs/types";

export const useGuideModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const openGuide = (type: string) => {
    dispatch(openModal({ activeModal: ModalTypes.guide }));
    navigate(
      `${location.pathname}?activeModal=${ModalTypes.guide}&type=${type}`,
    );
  };

  return { openGuide };
};
